import { Resources } from '@ragu-components/ord-resources';
import { useGetList } from 'react-admin';

import type { Agent } from '@ragu-components/ord-types';
import type { RaRecord, Identifier } from 'react-admin';

interface AgentPairs {
  users: Map<string, Identifier>;
  groups: Map<string, Identifier>;
}

interface UseAgentsDataReturn {
  agents: RaRecord[];
  userIds: string[];
  groupIds: string[];
  agentPairs: AgentPairs;
  loaded: boolean;
}

export const useAgentsData = (record: RaRecord | undefined): UseAgentsDataReturn => {
  const { data: agents } = useGetList<Agent>(Resources.agents, {
    filter: { active: 'fiql', fiql: `queue.id==${record?.id as string}` },
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'name', order: 'ASC' },
  });
  const processedAgents = (() => {
    const result: {
      userIds: string[];
      groupIds: string[];
      agentPairs: AgentPairs;
    } = {
      userIds: [],
      groupIds: [],
      agentPairs: {
        users: new Map(),
        groups: new Map(),
      },
    };

    if (agents === undefined) {
      return result;
    }

    for (const agent of agents) {
      if ('user' in agent && agent.user !== null && agent.user !== undefined) {
        result.userIds.push(agent.user.id);
        result.agentPairs.users.set(agent.user.id, agent.id);
      } else if ('group' in agent && agent.group !== null && agent.group !== undefined) {
        result.groupIds.push(agent.group.id);
        result.agentPairs.groups.set(agent.group.id, agent.id);
      }
    }

    return result;
  })();

  const { userIds, groupIds, agentPairs } = processedAgents;
  const loaded = agents !== undefined;

  return {
    agents: agents ?? [],
    userIds,
    groupIds,
    agentPairs,
    loaded,
  };
};
